
export class JwtTokens {
refreshToken: string;
token: string;
}

